<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <table-box ref="tableBox" :tableTitle="'账号管理'" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #title-right>
          <div class="search-div">
            <label>
              <select v-model="searchType">
                <option value="1">账号</option>
                <option value="2">姓名</option>
              </select>
            </label>
            <label>
              <input class="search-input" type="text" maxlength="20" v-model="searchMsg" placeholder="搜索相关数据..." />
            </label>
            <input class="search-btn" type="button" value="搜索" @click="onSearch" />
          </div>
        </template>
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th v-if="isOperation" class="operation-th">操作</th>
        </template>
        <template v-if="$validateAuthority(3700000,3702000,3702001)" #tableSubHead>
          <th class="table-sub-head-th" :colspan="tableFieldNum">
            <div class="div-btn cursor-el append-btn" @click="onShowAddManager">
              <img src="../../assets/add-data.png" height="14" width="14" alt="" />
              <label class="cursor-el">创建账号</label>
            </div>
          </th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td v-if="isOperation">
              <div class="operation-btn-div">
                <template v-if="$validateAuthority(3700000,3702000,3702002)">
                  <span v-if="props.item.state === 1" class="cursor-el" @click="onChangeState(props.item.id, props.item.name, false)">禁用</span>
                  <span v-else class="cursor-el" @click="onChangeState(props.item.id, props.item.name, true)">启用</span>
                </template>
                <span v-if="$validateAuthority(3700000,3702000,3702004)" class="cursor-el" @click="onShowEditManagerPwd(props.item)">修改密码</span>
                <span v-if="$validateAuthority(3700000,3702000,3702003)" class="cursor-el" @click="onShowEditManager(props.item)">编辑</span>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../../components/TableBox";
import ManagerAddLayer from "../layer/ManagerAddLayer";
import ManagerEditLayer from "../layer/ManagerEditLayer";
import ManagerPwdEditLayer from "../layer/ManagerPwdEditLayer";
import { getManagerItems, postEditManagerState } from "../../common/api";

export default {
  name: "Managers",
  components: { TableBox, ManagerAddLayer, ManagerEditLayer, ManagerPwdEditLayer },
  data() {
    return {
      action: getManagerItems,
      reloadData: false,
      searchType: "1",
      searchMsg: "",
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20
      },
      tableField: [
        { state: true, alias: "编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "账号", name: "acc", title: "acc", isHtml: false, value: this.getObjValue },
        { state: true, alias: "姓名", name: "name", title: "name", isHtml: false, value: this.getObjValue },
        { state: true, alias: "联系电话", name: "phone", title: "phone", isHtml: false, value: this.getObjValue },
        { state: true, alias: "类型", name: "type", title: "type", isHtml: false, value: this.getObjValue },
        { state: true, alias: "角色/商会", name: "group", title: "group", isHtml: false, value: this.getObjValue },
        { state: true, alias: "账号状态", name: "state", title: "state", isHtml: true, value: this.getObjValue },
        { state: true, alias: "创建时间", name: "createTime", title: "createTime", isHtml: false, value: this.getObjValue },
        { state: true, alias: "创建人", name: "creator", title: "creator", isHtml: false, value: this.getObjValue }
      ]
    };
  },
  computed: {
    isOperation() {
      return this.$hasAuthority(2400000,2402000,[2402002]);
    },
    tableFieldNum() {
      let num = this.isOperation ? 1 : 0;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      if (field === "state") {
        return item[field] === 1 ? "<span class='success-txt'>启用</span>" : "<span class='red-txt'>禁用</span>";
      } else if (field === "type") {
        return item[field] === 1 ? "平台管理员" : "商会管理员";
      } else {
        return item[field];
      }
    },
    onReloadData() {
      this.reloadData = true;
    },
    onSearch() {
      this.queryParams.type = this.searchType;
      this.queryParams.msg = this.searchMsg.trim();
    },
    onShowAddManager() {
      this.$layer.iframe({
        content: {
          content: ManagerAddLayer,
          parent: this,
          data: {
            refreshData: this.onReloadData
          }
        },
        area: ["800px", "680px"],
        title: "创建账号"
      });
    },
    onShowEditManagerPwd(item) {
      this.$layer.iframe({
        content: {
          content: ManagerPwdEditLayer,
          parent: this,
          data: {
            managerInfo: item,
            refreshData: this.onReloadData
          }
        },
        area: ["500px", "300px"],
        title: "编辑账号密码"
      });
    },
    onShowEditManager(item) {
      this.$layer.iframe({
        content: {
          content: ManagerEditLayer,
          parent: this,
          data: {
            managerInfo: item,
            refreshData: this.onReloadData
          }
        },
        area: ["600px", "500px"],
        title: "编辑账号"
      });
    },
    onChangeState(managerId, managerName, isEnable) {
      this.$layer.confirm(`是否【${isEnable ? "启用" : "禁用"}】管理员【${managerName}】？`, layerid => {
        postEditManagerState({ managerId: managerId, state: isEnable ? 1 : 0 })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .search-div {
      height: 100%;
      display: flex;
      select {
        width: 110px;
        height: 100%;
        border: 1px solid #dcdcdc;
      }
      .search-input {
        width: 140px;
        height: 33px;
        border: 1px solid #dcdcdc;
        padding: 0 15px;
        margin-left: 5px;
      }
      .search-btn {
        width: 80px;
        height: 100%;
        color: #f4f6f5;
        border: none;
        background: #4676c8;
      }
    }
    .operation-th {
      width: 120px;
    }
    .table-sub-head-th {
      .div-btn {
        float: left;
        width: 88px;
        height: 23px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
      .append-btn {
        margin-left: 15px;
        margin-right: 10px;
      }
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>